export default __webpack_public_path__ + "static/media/noTestimonial.da1264a5.svg";